import { createSelector } from '@reduxjs/toolkit';
import {
  selectProjectsDetails,
  selectOptionsPercentTotal,
  selectOptionsPlusTotal,
} from '../project/projectSelectros';

export const selectOther = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.other || {}
);

export const selectOtherCalculationParams = createSelector(
  selectOther,
  projectOther => projectOther.calculationOptions || {}
);

export const selectOtherPagesTotal = () => {
  return {
    discount: 0,
    totalPricePages: 0
  };
};

export const selectOtherOptionsTotal = createSelector(
  selectOtherPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectOtherTotal = createSelector(
  selectOtherPagesTotal,
  selectOtherOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectOtherTotalForAsap = createSelector(
    selectOtherTotal,
    (totalPrice) => {
      return totalPrice / 2;
    }
);

export const selectOtherEta = () => ({
  etaText: '',
  etaIsExists: false
});

export const selectOtherDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});

